import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { styled } from '@mui/material';
import MuiTypography from '@mui/material/Typography';
import { useMemo } from 'react';
import { SUPPORTED_FIELD_TYPES } from '../types.js';
import Field from '../Field/Field.js';

const GroupDescription = styled(MuiTypography) `
  color: ${({ theme }) => theme.palette.N20.main};
  margin-top: 4px;
`;
const FieldsContainer = styled('div') `
  margin-top: 16px;
`;
const GroupInner = ({ values, setValue, setting, errors }) => {
    const { field, description } = setting;
    const fields = useMemo(() => (Array.isArray(field) ? field : [field]), [field]);
    return (jsxs(Fragment, { children: [description && (jsx(GroupDescription, Object.assign({ "data-testid": "groupDescription", variant: "body5" }, { children: description }))), jsx(FieldsContainer, { children: fields
                    .filter(field => !field.hidden && field.type in SUPPORTED_FIELD_TYPES)
                    .map(field => (jsx(Field, { field: field, value: values[field.key], onChange: value => setValue(field.key, value), error: errors ? errors[field.key] : null }, field.key))) })] }));
};

export { GroupInner as default };
//# sourceMappingURL=GroupInner.js.map
